import loadable from '@loadable/component'

export default [
  {
    path: '/CardMixture',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-CardMixture" */ '~/pages/CardMixture'
        )
    ),
  },
  {
    path: '/CardMixture/Rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-game-GiftBook-CardMixture-Rule" */ '~/pages/CardMixture/rule'
        )
    ),
  },
]
